import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { DiaInhabil } from './dias-inhabiles.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root'
})
export class DiasInhabilesService {

  private hitosURL: string = urlJoin(environment.apiURL, 'hitos');

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getDiasInhabilesExpediente(id_expediente: string): Observable<DiaInhabil[]> {
    const getHitosExpedienteURL = urlJoin(this.hitosURL, '/expediente/', id_expediente);
    return this.http.get<DiaInhabil[]>(getHitosExpedienteURL)
      .pipe(
        map((hitos) => hitos.filter((hito) => hito.tipo === 'DIA_INHABIL')),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }

  newDiaInhabil(diaInhabil: DiaInhabil): Observable<any> {
    return this.http.post<DiaInhabil>(this.hitosURL, diaInhabil)
      .pipe(
        tap(() => {
          const newDiaInhabilSuccessMessage: string = $localize`:@@newDiaInhabilSuccessMessage:Nuevo día inhábil creado correctamente`;
          this.notificationsService.showSuccessNotification(newDiaInhabilSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }

  deleteDiaInhabil(id: string): Observable<any> {
    const deleteHitoURL = urlJoin(this.hitosURL, id.toString());
    return this.http.delete<DiaInhabil>(deleteHitoURL)
      .pipe(
        tap(() => {
          const deleteDiaInhabilSuccessMessage: string = $localize`:@@deleteDiaInhabilSuccessMessage:Día inhábil eliminado correctamente`;
          this.notificationsService.showSuccessNotification(deleteDiaInhabilSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }
}
